import { takeEvery, call, put } from 'redux-saga/effects'
import { ADMIN_ORGANIZATION_USERS } from 'store/entities/organizations/actionTypes'
// @ts-ignore
import makeAPIRequest from 'store/entities/api/sagas'
// @ts-ignore
import { GET_ADMIN_ORGANIZATION_USERS_PATH } from 'app/constants/api/organizations'
import { adminOrganizationUsers } from 'store/entities/organizations/actions'

export default function* organizationAdminUsersGetSaga() {
  yield takeEvery(ADMIN_ORGANIZATION_USERS.GET.REQUEST, handleOrganizationAdminUsersGet)
}

export function* handleOrganizationAdminUsersGet() {
  try {
    const response = yield call(makeAPIRequest, GET_ADMIN_ORGANIZATION_USERS_PATH, {
      method: 'GET',
    })
    const { data } = response.data
    yield put(adminOrganizationUsers.get.success(data))
  } catch (badResponse) {
    yield put(adminOrganizationUsers.get.fail())
    console.log(badResponse)
  }
}
